(function (angular) {
    'use strict';


    soberTime.$inject = [
        '$interval',
        'timeAgoFilter',
    ];

    /**
     * Angular directive that renders a sentence informing how long ago a date occurred.
     *
     * @note null dates, or dates than occurred more than 1 month ago will always output the string
     * "more than a month ago" as per client request.
     *
     * @example
     * <span sober-time="updatedAt"></span>
     * might become
     * "about 20 hours ago"
     *
     * <span sober-time="createdAt"></span>
     * might become
     * "more than a month ago"
     */
    function soberTime($interval, timeAgoFilter) {
        function link($scope, $element) {
            if (!$scope.soberTime) {
                $scope.time_ago = 'more than a month ago';
                return false;
            }

            // check if under 30 days before using timeAgo
            const now = window.moment();
            const dateTime = window.moment($scope.soberTime, 'YYYY-MM-DD HH:mm:ss');
            const monthsAgo = window.moment.duration(now.diff(dateTime)).months();

            if (monthsAgo >= 1) {
                $scope.time_ago = 'more than a month ago';
            } else {
                const t = $scope.soberTime.split(/[\- :]/);
                // create Date object with UCT time.
                const date = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));
                const postStr = +new Date($scope.soberTime) < +new Date() ? ' ago' : '';

                // set time ago for the first time.
                $scope.time_ago = timeAgoFilter(date) + postStr;

                // update the time every second.
                const stop = $interval(() => {
                    $scope.time_ago = timeAgoFilter(date) + postStr;
                }, 1000);

                // cancel the interval on scope destroy.
                $scope.$on('destroy', () => {
                    $interval.cancel(stop);
                });

                // set the elements title attr to the user's local time string.
                $element.attr('title', date.toLocaleString());
            }
        }

        return {
            link,
            restrict: 'A',
            scope: {
                /**
                 * Value that can be passed to the moment constructor.
                 *
                 * @var {Date | number | string | Moment} soberTime
                 */
                soberTime: '=',
            },
            template: '{(time_ago)}',
        };
    }

    angular
        .module('app')
        .directive('soberTime', soberTime);

}(angular));
